// Firestore collection names, centralized so they stop being string literals
// scattered across src/ and functions/.
const COLLECTIONS = Object.freeze({
  USERS: 'users',
  MEALS: 'meals',
  BOOKINGS: 'bookings',
  REVIEWS: 'reviews',
  TALENT_POOL: 'talentPool',
  OUTBOX: 'outbox',
  CONTACT_GRANTS: 'contactGrants',
});

module.exports = { COLLECTIONS };
